export default function Logik() {
  return (
    <div className="container mt-20 mx-auto">
      <div>
        <h4 className="text-dxl md:text-d2xl font-bold text-doctio-green">
          Logik som klinisk støtteredskab
        </h4>

        <p>
          Logikker fungerer som automatiserede beslutningstager. Næsten alle
          klik-elementer kan tilknyttes en logik. Når en logik aktiveres, vil
          det tilknyttede klik-element ændre farve til gult for at angive, at
          logikken er blevet udløst.
        </p>

        <p>
          Vi starter med at udforske logikken for tjekbokse, hvor vi
          demonstrerer, hvordan en tjekboks kan aktiveres baseret på værdier i
          en tilknyttet talboks. Derefter gennemgås forskellige tilgangsmetoder
          for andre elementer som tekstbokse, talbokse, singlevalg og multivalg.
        </p>

        <p>
          I hver demonstration guides man igennem processen med at tilføje
          logikker til de forskellige elementer ved at definere betingelser og
          handlinger. Der lægges vægt på vigtigheden af at navngive elementerne
          korrekt for at opnå en klar og overskuelig struktur.
        </p>

        <p>
          Yderligere udforskes funktionen for vis/skjul, hvor det forklares, at
          man kan tilføje en regel for, hvornår et felt skal vises. Og at man
          kan indsætte andre klikelementer i en vis/skjul funktion, som også kan
          knyttes op på logik.
        </p>
      </div>

      <div className="mt-10">
        <iframe
          width="560"
          height="315"
          className="h-[200px] md:h-[600px]"
          style={{ width: "100%", borderRadius: "10px" }}
          src="https://www.youtube.com/embed/AfNwnJjm91g?si=itGC_oblJuIM00Uh"
          title="YouTube video player"
          frameBorder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={true}
        ></iframe>
      </div>
    </div>
  );
}
